import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";


pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// -----------------------------
// 🔍 Extract raw text from PDF
// -----------------------------

export async function parseSnappyPDF(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

  let fullText = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    const pageText = content.items.map((item) => item.str).join(" ");
    fullText += pageText + "\n";
  }

  return fullText;
}

export function extractSnappyFields(text) {
  const getValue = (label) => {
    const regex = new RegExp(`${label}\\s+£?(\\d+\\.\\d{2})`);
    const match = text.match(regex);
    return match ? parseFloat(match[1]) : 0;
  };

  const getDate = () => {
    const match = text.match(/Transaction Date Range\s+(\d{2}\/\d{2}\/\d{4})/);
    if (!match) return null;
    const [d, m, y] = match[1].split("/");
    return `${y}-${m}-${d}`;
  };

  return {
    snappyReportDate: getDate(),

    // Sales
    totalProductSales: getValue("Total Product Sales"),
    netSales: getValue("Net Sales"),

    // Discounts
    multiBuyDiscounts: getValue("Multi Buy Discounts"),
    couponDiscounts: getValue("Coupon Discounts"),
    loyaltyDiscounts: getValue("Loyalty Discounts"),
    totalDiscounts: getValue("Total Discounts"),

    // Surcharges
    deliveryCharge: getValue("Delivery Charge"),
    driverTips: getValue("Driver Tips"),
    bagCharge: getValue("Bag Charge"),
    otherSurcharges: getValue("Other Surcharges"),
    totalSurcharges: getValue("Total Surcharges"),

    // Refunds
    refunds: getValue("Refunds"),

    // Payment Methods
    CardSalesbeforeRefunds: getValue("Card Sales before refunds"),
    CardSalesafterRefunds: getValue("Card Sales after refunds"),
    cashSales: getValue("Cash Sales"),
    SnappycustomerFeeonCashSales: getValue("Snappy customer fee on cash sales"),

    // Charges
    snappyFundedDiscounts: getValue("Snappy Funded Discounts"),

    // Retailer Fee
    retailerCharge: getValue("Retailer Charge"),
    retailerEposCharge: getValue("Retailer Epos Charge"),
    Vat: getValue("Vat"),
    totalRetailerFee: getValue("Retailer Fee Per Invoice")
  };
}

// --------------------------------------
// 🏪 Parse One Stop: Match selected date & extract fields
// --------------------------------------

export async function extractTextFromPDF(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

  let text = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    const pageText = content.items.map((item) => item.str).join(" ");
    text += pageText + "\n";
  }

  return text;
}

export async function parseOneStopPDF(file, selectedDate) {
  // 1. Extract text from PDF
  const text = await extractTextFromPDF(file);

  // 2. Extract date range from PDF text (e.g. "31/08/2025 - 06/09/2025")
  const dateRangeMatch = text.match(/Date Range\s*:\s*([\d\/\- ]+)/);
  const dateRange = dateRangeMatch ? dateRangeMatch[1].trim() : "";

  // 3. Calculate day name for selectedDate
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const selected = new Date(selectedDate);
  const transactionDay = dayNames[selected.getDay()];
  const dayIndex = dayNames.indexOf(transactionDay);

  // 4. Check if selected date is within the PDF date range
  function isDateInRange(selectedDate, dateRange) {
    if (!dateRange) return false;
    const [start, end] = dateRange.split("-").map(s => s.trim());
    // Parse as dd/mm/yyyy
    const parse = s => {
      const [d, m, y] = s.split("/").map(Number);
      const dt = new Date(y, m - 1, d);
      dt.setHours(0, 0, 0, 0);
      return dt;
    };
    const startDate = parse(start);
    const endDate = parse(end);
    const sel = new Date(selectedDate);
    sel.setHours(0, 0, 0, 0);
    const inRange = sel >= startDate && sel <= endDate;
    console.log("Selected:", sel, "Start:", startDate, "End:", endDate, "dateInRange:", inRange);
    return inRange;
  }
  const dateInRange = isDateInRange(selectedDate, dateRange);
console.log("PDF TEXT:\n", text);
  // --- Extract TOTAL TILL SALES from Till Sales section ---
function getRowValues(label) {
  // Match the label anywhere in the line, then grab all numbers after it (handles multiple spaces)
  const regex = new RegExp(label.replace(/ /g, "\\s*") + "\\s+((?:[\\d\\.,]+\\s+)+[\\d\\.,]+)", "i");
  const lines = text.split('\n');
  for (const line of lines) {
    const match = line.match(regex);
    if (match) {
      return match[1]
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(x => parseFloat(x.replace(/,/g, "")));
    }
  }
  return null;
}
  const totalTillSalesArr = getRowValues("TOTAL TILL SALES");
  const totalTillSales = totalTillSalesArr ? totalTillSalesArr[dayIndex] : 0;

// --- Extract Variances section ---
const variancesSectionMatch = text.match(/Variances([\s\S]+?)Tenders/);
const variancesSection = variancesSectionMatch ? variancesSectionMatch[1] : "";

function getVarianceValues(label) {
  const regex = new RegExp(label.replace(/ /g, "\\s*") + "\\s+([\\d\\.\\s,-]+)");
  const match = variancesSection.match(regex);
  if (!match) return null;
  return match[1]
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(x => parseFloat(x.replace(/,/g, "")));
}

const tillVarianceArr = getVarianceValues("Till");
const tillVariance = tillVarianceArr ? tillVarianceArr[dayIndex] : 0;


  // --- Extract Tenders section as before ---
  const tendersSectionMatch = text.match(/Tenders([\s\S]+?)Deposits/);
  const tendersSection = tendersSectionMatch ? tendersSectionMatch[1] : "";

  function getTenderValues(label) {
    const regex = new RegExp(label.replace(/ /g, "\\s*") + "\\s+([\\d\\.\\s,-]+)");
    const match = tendersSection.match(regex);
    if (!match) return null;
    return match[1]
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map(x => parseFloat(x.replace(/,/g, "")));
  }
  // --- Extract category sales from Till Sales section ---
const lotteryArr = getLotteryValues("Lottery");
const lottery = lotteryArr ? lotteryArr[dayIndex] : 0;
function getLotteryValues(label) {
  // Search the Till Sales section for the Lottery row
  const tillSalesSectionMatch = text.match(/Till Sales([\s\S]+?)Pay In/);
  const tillSalesSection = tillSalesSectionMatch ? tillSalesSectionMatch[1] : "";
  const regex = new RegExp(label.replace(/ /g, "\\s*") + "\\s+([-\\d\\.\\s,]+)");
  const match = tillSalesSection.match(regex);
  if (!match) return null;
  return match[1]
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(x => parseFloat(x.replace(/,/g, "")));
}

  const newsArr = getRowValues("News");
  const tobaccoArr = getRowValues("Tobacco");
  const offLicenceArr = getRowValues("Off Licence");


  const news = newsArr ? newsArr[dayIndex] : 0;
  const tobacco = tobaccoArr ? tobaccoArr[dayIndex] : 0;
  const offLicence = offLicenceArr ? offLicenceArr[dayIndex] : 0;

  const tenderValues = {
    cash: getTenderValues("Cash"),
    visa: getTenderValues("VISA"),
    amex: getTenderValues("AMEX"),
    newsAccount: getTenderValues("News Account"),
    justEat: getTenderValues("Just Eat internet payment"),
    deliveroo: getTenderValues("Deliveroo internet payment"),
    vouchers: getTenderValues("Supplier Coupon"),
    mastercard: getTenderValues("MasterCard"),
    visaDebit: getTenderValues("Visa Debit"),
    debitMastercard: getTenderValues("Debit Mastercard"),
    cheque: getTenderValues("Cheque"),
  };
  console.log("🧾 Tenders Section:\n", tendersSection);

  // If not in range, return all zeros
  if (!dateInRange) {
    return {
      dateRange,
      dateInRange,
      transactionDay,
      cashSales: 0,
      cardSalesAfterRefunds: 0,
      newsAccount: 0,
      justEat: 0,
      deliveroo: 0,
      vouchers: 0,
      amex: 0,
      debitMastercard: 0,
      mastercard: 0,
      visa: 0,
      visaDebit: 0,
      cheque: 0,
      totalTillSales: 0,

    };
  }

  // 9. Compose result for the selected day
  return {
    dateRange,
    dateInRange,
    transactionDay,
    cashSales: tenderValues.cash?.[dayIndex] ?? 0,
    cardSalesAfterRefunds:
      (tenderValues.visa?.[dayIndex] ?? 0) +
      (tenderValues.mastercard?.[dayIndex] ?? 0) +
      (tenderValues.visaDebit?.[dayIndex] ?? 0) +
      (tenderValues.debitMastercard?.[dayIndex] ?? 0) +
      (tenderValues.amex?.[dayIndex] ?? 0),
    newsAccount: tenderValues.newsAccount?.[dayIndex] ?? 0,
    justEat: tenderValues.justEat?.[dayIndex] ?? 0,
    deliveroo: tenderValues.deliveroo?.[dayIndex] ?? 0,
    vouchers: tenderValues.vouchers?.[dayIndex] ?? 0,
    amex: tenderValues.amex?.[dayIndex] ?? 0,
    debitMastercard: tenderValues.debitMastercard?.[dayIndex] ?? 0,
    mastercard: tenderValues.mastercard?.[dayIndex] ?? 0,
    visa: tenderValues.visa?.[dayIndex] ?? 0,
    visaDebit: tenderValues.visaDebit?.[dayIndex] ?? 0,
    cheque: tenderValues.cheque?.[dayIndex] ?? 0,
    totalTillSales,tillVariance,lottery,
    news,
    tobacco,
    offLicence,
  
  };
}